/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useFetchLoggedUser } from '../user';
import { selectAuth, selectOrder } from '@/store/selectors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const table = queryKey[2];
  const userId = queryKey[3];

  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_free_tables?table=${table}&owner=${userId}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchFreeTables = () => {
  const { url } = useSelector(selectAuth);
  const { restaurant_table: table } = useSelector(selectOrder);
  const { data: loggedUser } = useFetchLoggedUser();
  return useQuery(['free-tables', url, table, loggedUser], fetcher, {
    enabled: !!loggedUser,
  });
};
